import React from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";

const DisclaimerCopyrights = () => {
  ChangeTitle("Disclaimer & Copyrights");

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Disclaimer & copyrights
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="">
            <p className="mb-[2rem] w-full legal-para">
              The contents of www.gcclawhelp.com are copyrighted, and all rights
              are reserved. Accessing, taking, or copying data or contents in
              whole or in part using AI, ChatGPT, API, or any other means is
              strictly prohibited and shall be considered
              copyright infringement. 
            </p>
            <p className="mb-[2rem] w-full legal-para">
              If you are interested in linking, quoting, or reprinting articles
              from GCC Law Help in whole or in part, please read our copyright
              policy:
            </p>
            <ul className="pl-[3.5rem] mb-[2rem] legal-ul-disc-b">
              <li className="mb-[1rem] legal-ul-disc-b-li">
                Cut-and-paste of entire or part of posts is strictly prohibited
                and will be taken very seriously. It is copyright infringement.
                Complete translations of our articles on separate websites or
                blogs are also banned.
              </li>
              <li className="mb-[1rem] legal-ul-disc-b-li">
                You may not republish articles/full or part posts without our
                direct written permission. Feel free to quote anything from this
                work with a link to it as a source but remember that this is
                copyrighted material.
              </li>
              <li className="mb-[1rem] legal-ul-disc-b-li">
                Always provide a hyperlink (full URL) to the article where the
                quote is from, and do not use techniques (like rel=nofollow)
                that try to hide credits from search engines. Copy the quoted
                material exactly, enclose it in quotation marks, and mention GCC
                Law Help immediately before or after the quote.
              </li>
              <li className="mb-[1rem] legal-ul-disc-b-li">
                All trademarks within are the property of their respective
                holders.
              </li>
              <li className="mb-[1rem] legal-ul-disc-b-li">
                Although the author believes the contents to be accurate at the
                time of publication, no liability is assumed for them, their
                application, or any consequences thereof. If any
                misrepresentations, errors, or other need for clarification is
                found, please contact us immediately.
              </li>
            </ul>
            <h1 className="mb-[2rem] legal-title-y">General Disclaimer</h1>
            <p className="mb-[2rem] w-full legal-para">
              Every effort has been made to avoid errors or omissions. Despite
              this, errors may creep in. Any mistake, error, or discrepancy
              noted may be brought to our notice and shall be handled. It is
              notified that neither GCC Law Help nor the authors will be
              responsible for any damage or loss of action to anyone of any kind
              in any manner. It is suggested that to avoid doubt, the reader
              should cross-check all the facts, laws, and contents of the
              material on the web with original Government publications or
              notifications.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              GCC Law Help and/or its directors, authorized editor, employees,
              agents, representatives, and authors make no representations about
              the suitability, reliability, availability, timeliness, and
              accuracy of the information, products, services, and related
              material contained in the GCC Law Help website for any purpose.
              All information, software, products, services, and related
              material are provided “as is.”
            </p>
            <p className="mb-[2rem] w-full legal-para">
              The material on this site and the associated web pages is general
              information and is not intended to be advice. Subscribers and
              readers should seek appropriate professional advice before acting
              based on any information contained herein. In, its directors,
              employees, agents, representatives, and the authors expressly
              disclaim all liability to any person, whether a subscriber or not,
              in respect of anything and of the consequences of anything done or
              omitted to be done by any such person in reliance upon the
              contents of this site and associated web pages.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              In no event shall GCC Law Help be liable for any direct, indirect,
              punitive, incidental, special, consequential damages or any
              damages whatsoever, including, without limitation, damages for
              loss of use, data, or profits arising out of the use or
              performance or inability to use the GCC Law Help the website or
              related services.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              GCC Law Help reserves the right to modify, alter, or update these
              terms of use and Disclaimer at any time, and you are bound by such
              modifications, alterations, or updates.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              Discussions on, or arising out of this, blog between contributors
              and other persons shall not create any attorney-client
              relationship.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              As such, this does not constitute specific legal advice. By using
              this blog, you understand and acknowledge that there is no
              relationship of whatsoever nature (including implied, legal, or
              fiduciary) between you and the publisher. The Blog should not be
              used as a substitute for specific legal advice.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              The views, opinions, or content expressed in this website are
              those of the author/(s) alone and do not necessarily reflect the
              official position of GCC Law Help  or any other agency,
              organization, employer, or company. Assumptions made in the
              analysis do not reflect the position of any entity other than the
              author/(s), and these views are subject to change, revision, and
              rethinking at any time. Please do not hold us to them in
              perpetuity.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              Your use of the service is solely at your own risk. The service is
              provided on an “as is” and “as available” basis only. GCC Law
              Help expressly disclaims all warranties of any kind, whether
              express or implied, including, but not limited to, the implied
              warranties of merchantability, fitness for a particular purpose,
              and non-infringement.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              Links on the blog may be used to link to another blog(s) or
              website. These links are provided solely as a courtesy to our blog
              visitors. GCC Law Help has no control over the linked sites or the
              materials, information, goods, or services available or contained
              on these linked sites. GCC Law Help is not responsible for and
              does not endorse or warrant in any way any materials, information,
              goods, or services available through such linked sites or any
              privacy or other practices of such sites. You do so at your own
              risk if you access any linked sites. GCC Law Help reserves the
              right to terminate any link at any time. Many of the links on this
              blog will take you to sites operated by third parties. The
              contributors of this blog have not reviewed all of the information
              on these sites or the accuracy or reliability of any information,
              data, opinions, advice, or statements on these sites. The
              contributors do not endorse these sites or the opinions they may
              offer. These third-party links are provided solely for discussing
              and thinking about related information and other related topics.
              It is also possible that some of the linked pages may become
              inactive after the lapse of time.  GCC Law Help neither endorses
              in any way nor offers any judgment or warranty and accepts no
              responsibility or liability for the authenticity or availability
              of any of the goods or services or for any damage, loss, or harm,
              direct or consequential, or any violation of local or
              international laws that may cause infringement by your visiting
              and transacting on these websites as well as on using websites
              links which are provided on these websites.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              We are not liable or responsible for any loss caused by using our
              website; we are not liable if any person suffers a loss while
              using our content. We can change our website’s content anytime
              without notifying registered or regular visitors. We cannot
              guarantee the security of your data transmitted through the
              Website; any transmission is at your own risk. Once we have
              received your information, we will use strict physical,
              electronic, and procedural safeguards to prevent unauthorized
              access.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              The contents of this website are for information purposes only, to
              enable the public to have quick and easy access to information,
              and do not purport to be legal documents. GCC Law Help does not
              warrant the accuracy or completeness of this website's
              information, text, graphics, links, or other items.  GCC Law Help
              may change the contents or the information described therein at
              any time without notice. Commercial use of web content is
              prohibited without written permission from GCC Law Help.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              It is notified that neither GCC Law Help nor the service provider
              will be responsible for any loss or damage to anyone. Viewers are
              advised to verify the content from original Government
              Acts/Rules/Notifications, etc.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              We are just providing a platform using third-party services where
              you can list or update your personal and professional information
              for the general public to access. We are not responsible or liable
              for anything.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              You agree that your details will be published to the general
              public and will be available to the general public. Since a URL is
              generated for your listing, your listing will be available at
              Google and other search engines, and anyone can access your
              personal and professional details. GCC Law Help will assign you a
              user ID and a password when You register. Your user ID and
              password shall only be used by You. You are solely responsible for
              maintaining and protecting the confidentiality of Your user ID and
              password. You are fully responsible for all activities under Your
              user ID and password. You may not share your user ID and password
              with anyone else, and you are solely responsible for maintaining
              and protecting the confidentiality of your user ID and password.
              You are fully responsible for all activities under your user ID
              and password. You can access and update your login information on
              your “User Dashboard” webpage.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              The personal information you provide and that we collect is stored
              within databases controlled by a third-party
              hosting http://www.gcclawhelp.com website at WordPress and using
              various plugins provided by multiple entities/persons worldwide.
              Since no security system is impenetrable, we cannot guarantee the
              security of our databases, nor can we guarantee that the
              information you supply will not be intercepted while being
              transmitted to us over the Internet. Please read the terms and
              conditions of these third parties. Your information may be
              transferred to and maintained on computers outside your state,
              province/territory, or country where the privacy laws may not be
              as protective as those where you live. Your information may be
              subject to access requests from governments, courts, law
              enforcement officials, and national security authorities in India
              according to its laws. Subject to the applicable laws, we will
              make reasonable efforts to ensure that appropriate protections are
              in place to protect personal information. By submitting your
              Personal Information, you consent to having your data transferred
              to, processed, and stored in any country.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              GCC Law Helps does not guarantee the accuracy, integrity, quality,
              or appropriateness of any content transmitted to or through the
              Platform. You acknowledge that GCC Law Helps acts as a passive
              conduit and an interactive computer service provider for
              publishing and distributing content you or a service provider
              posted. You understand that all content posted on, transmitted
              through, or linked through the Platform is the sole responsibility
              of the person from whom such content originated. You know that GCC
              Law Helps does not control and is not responsible for the content
              available through the Platform and that using the Platform may
              expose you to inaccurate, misleading, or offensive content. You
              agree that you must evaluate, make your judgment, and bear all
              risks associated with using any content.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              You further acknowledge that GCC Law Helps has no obligation to
              screen, preview, monitor, or approve any content published by you,
              a service provider, or a third party. However, GCC Law Helps
              reserves the right to review and delete any content that, in its
              sole judgment, violates the terms and conditions of this
              Agreement. By participating in the Program and using the Platform,
              you agree that it is solely YOUR RESPONSIBILITY to evaluate your
              risks to bear associated with the use, accuracy, usefulness,
              completeness, or appropriateness of any content that you submit,
              receive, access, transmit, or otherwise convey through the
              Platform. Under no circumstances will GCC Law Helps be liable in
              any way for any content provided by you, a service provider, or a
              third party, including, without limitation, content that contains
              any errors, omissions, defamatory statements, or confidential or
              private information or for any loss or damage of any kind incurred
              as a result of the use of any content submitted, accessed,
              transmitted or otherwise conveyed via the Platform. You waive the
              right to bring or assert any claim against GCC Law Helps relating
              to your content or the content of a service provider or other
              third party and release GCC Law Helps from any liability for or
              relating to any such content.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              GCC Law Helps do not endorse and are not responsible or liable for
              any content, data, advertising, products, goods, or services
              available or unavailable from or through service providers. You
              agree that should you use or rely on such content, data,
              advertisement, products, goods, or services, available or
              unavailable from or through any service provider, GCC Law Helps is
              not responsible or liable, indirectly or directly, for any damage
              or loss caused or alleged to be caused by or in connection with
              such use or reliance. Your dealings with or participation in
              promotions of any service provider, and any other terms,
              conditions, representations, or warranties associated with such
              dealings (including any Service Contracts), are between you and
              such service provider exclusively and do not involve GCC Law
              Helps. It would be best to make whatever investigation or other
              resources you deem necessary or appropriate before hiring or
              engaging service providers.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              You agree that GCC Law Helps is not responsible for the
              accessibility or unavailability of any service provider or your
              interactions and dealings with them. You waive the right to bring
              or assert any claim against GCC Law Helps relating to any
              interactions or dealings with any service provider and release GCC
              Law Helps from any liability for or relating to any interactions
              or dealings with service providers.
            </p>
            <h1 className="mb-[2rem] legal-title-y">
              Social Media Group Disclaimer
            </h1>
            <p className="mb-[2rem] w-full legal-para">
              Group members cannot circulate illegal messages that are dangerous
              to national security, violate IT laws, or are objectionable. The
              group admin doesn’t want such content and is not responsible. If
              you join the group, you are willing to share your contact number
              publicly; anyone can message or call you. If you have any privacy
              concerns, immediately leave the group or do not join it. If you
              share or post anything in the group, you alone will be fully
              responsible for the post you shared or posted. Group members and
              admin will share anything shared or posted in the group with other
              groups and people in public without your permission; therefore, do
              not post anything if you have any privacy concerns. The group
              admin can remove any group member without any intimation or
              reason.
            </p>
            <p className="mb-[2rem] w-full legal-para">
              The creators, admins, and officials of this WhatsApp group are not
              and will not be held responsible for any content on this group
              that is deemed to be inappropriate, defamatory, insulting,
              incorrect, or in any other way legally actionable. This includes
              content that may be racially offensive or of a sexually offensive
              nature. We, at this moment, indemnify and distance ourselves from
              such content. We are ultimately not responsible for content users'
              posts without prior consent or approval. Users are responsible for
              their conduct and the content which they post. By voluntarily
              entering this group and not removing yourself from it, you place
              yourself under the rules and guidelines of this group, which the
              admins and officials regularly post. Users who transgress the
              stated regulations of this group will be removed as soon as
              humanly possible (or as soon as it is brought to our attention).
              It would be best if you did not take anything you see, hear, or
              read in this group as legal advice or professional guidance.
              Before acting on it, you should verify any information given here
              for yourself. This group exists for information purposes only.
              These terms are not negotiable, and by remaining a member of this
              group, you agree to such terms. If you disagree, please leave the
              group immediately.
            </p>
            <h1 className="mb-[2rem] legal-title-b">
              By using this website, you agree to the following also:
            </h1>
            <ol className="pl-[1.5rem] lg:pl-[2.2rem] legal-ol-num-g">
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                By sending a request to become a member or by joining as a
                member of the Network of GCC Law Help, I acknowledge and agree
                to the following group rules, policy, and disclaimer in Groups,
                including WhatsApp groups. I also agree that the Admin team has
                the right to restrict admission, remove, or ban anyone from any
                group without notification. Social media groups include
                Facebook, Google, WhatsApp, LinkedIn, and other networking
                groups on various social media platforms. By sending a request
                to become a member or by joining as a member, I agree to display
                and share my real name, accurate recent face picture as a
                Profile Display Picture, and basic information with members of
                the Network of GCC Law Help in Social Media Groups, including
                WhatsApp groups. I also agree that I will keep working and use
                the local mobile phone number as my WhatsApp number.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                As a Network of GCC Law Help group member, I will abide by the
                group rules and use only the group to connect with professionals
                in the same field for networking. I will not be involved in any
                inappropriate, unethical, or illegal activities, including but
                not limited to forwarding any inappropriate posts, using foul
                and vulgar language, sharing inappropriate posts, posting
                promotions of any kind, personal attacks, personal insulting
                messages, bullying of any member, sending unsolicited personal
                messages to any group member whom I don’t have previous
                acquaintance with, or posting inappropriate messages, images,
                videos or inappropriate comments.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                As a member of this Network of GCC Law Help, I accept the
                leadership of Admins in managing and moderating the group
                activities in social media groups, including WhatsApp groups,
                etc., and I will not modify or change the name and icon of any
                of the groups. I also agree that the Admin may verify before
                admission to any group. I agree to provide true, verifiable
                information to the Admin and not to give any false information
                at any time.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                I understand by voluntarily joining the Network of GCC Law
                Help Social Media Groups, including WhatsApp groups, etc.,
                during my participation in WhatsApp Groups, my information,
                including my phone number, name, photos, etc., may be exposed to
                other members of the WhatsApp groups. I may be exposed to risks
                that include, but are not limited to, information shared with
                other members and the dangers of severe loss or damage
                (“Injuries and Damages”). I agree to WAIVE, DISCHARGE CLAIMS,
                AND RELEASE FROM LIABILITY Network of GCC Law Help Group, its
                Organizers, Group Admins or Managers, Meetup Organizing
                Committee Members, and Leaders from any liability on account of,
                or in any way resulting from any damages, in any way connected
                with the activities I participate through this Network of GCC
                Law Help Social Media Groups, including WhatsApp groups, etc.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                As a member of this Network of GCC Law Help, I voluntarily
                participate in networking and discussions in social media
                groups, including WhatsApp groups. I understand the Group is not
                responsible for any damage or injury through communication,
                participation, or information sharing.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Further agree to HOLD HARMLESS Network of GCC Law Help in Social
                Media Groups, including WhatsApp groups, its Admins, and
                leaders, from any claims, damages, injuries, or losses caused by
                my negligence. At the same time, I participate in discussions
                and communication. I understand and intend that this assumption
                of risk and release is binding upon my heirs, executors,
                administrators, and assigns, and it includes any minors
                accompanying me on the Activity.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                If I bring guests to participate in any event, I take full
                responsibility for the guests and agree to all the above terms
                and conditions. I acknowledge that I understand the Network of
                GCC Law Help. Groups and their Admins are not responsible and
                liable for any damage, loss, or injury during any communication,
                posts, activities, meetup events, or any related unspecified
                activities.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Also, as a Group member of the Network of GCC Law Help Social
                Media Groups, including WhatsApp groups, etc., I agree that I
                will not disclose, post, or share, in any manner, any
                inappropriate messages, any confidential or proprietary
                information, or confidential material or copyright information
                through any of the Social Media Groups, including WhatsApp
                Groups. Group Admin and Managers are not responsible in any way
                for any inappropriate posts or any violation of any posting made
                by any group member.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Group members are required not to make defamatory statements,
                personal attacks, or bully anyone in the group in any manner and
                not to infringe or authorize any infringement of copyright or
                any other legal right by any communications made in the group.
                Any such communication is contrary to the group’s policy. The
                Group will not accept any liability for such communication,
                breach of confidentiality, copyright violation, violation of
                intellectual property rights, or any damages or any other
                liability arising. The information, discussion, comments, and
                contents of Social Media Groups are purely for informational and
                networking purposes only and are not a complete reference
                resource.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                The discussions or comments posted by individual members
                via Social Media Group are not intended to be, and should not be
                considered, a substitute for professional, ethical, and legal
                advice or professional consultation or legal or other
                professional advice. The group admin team is not responsible for
                any posts, including but not limited to Job posts, Sale posts,
                promotional posts, matrimonial posts, and meetup events posted
                in the groups.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                The Group also does not recommend or endorse any specific
                providers, Job providers, consultants, Recruiters, Service
                Providers, Websites, Products, Opinions, or other information
                that group members may mention or may access or discover via any
                links posted in the group. I will always seek professional legal
                and ethical advice from qualified professionals related to any
                matter, including but not limited to education, sales, job,
                immigration, etc. I may not rely on any information accessible
                through this group or via any website links posted on the group
                to my specific circumstances.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Discussions, comments, job opportunities, sales, trades,
                immigration procedure tips, events, promotions, and any other
                kinds of postings on this group are not legal or professional
                advice and should not be relied upon. The opinions expressed at
                or through this group are the opinions of the individual member
                and may not reflect the views of the group or group admin.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                I have voluntarily joined the Network of GCC Law Help social
                media groups, including WhatsApp groups. I can leave the group
                anytime to network. Once I leave the group, the Admin reserves
                the right to restrict or deny my re-entry into the same or any
                of the groups.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Group Admins also have the right to remove and ban users who
                violate group policy and rules. The discussions posted on one
                WhatsApp group could be forwarded to our other groups on the
                NETWORK OF GCC Law Help, Including but not limited to WhatsApp,
                LinkedIn, Facebook, Google Groups, Twitter, Blog, yahoo groups,
                etc.; as a member of this group, I acknowledge that I am aware
                of this and agree that I will not violate any copyright
                violation or confidentiality violations by posting any
                information on these groups which will also be forwarded
                manually or automatically fed to other Social Media Group and
                lists of NETWORK of GCC Law Help.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                I understand that comments, discussions, and other postings on
                this group could be accessed by non-group members through
                various social media. Group Admins and Managers are not
                responsible for any comments, postings, or discussions posted by
                individual members of this Group, whether manually forwarded or
                automatically fed to other similar Groups through various feeds.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Group Admins reserve the right to admission to anyone and remove
                any member from any Group without any further notification.
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                The Admins have the right to modify the group rules, group
                policy, and disclaimer anytime without notice to manage
                effectively and moderate group activities. As a member of the
                group, it’s my responsibility to update myself with changes and
                modifications in the Group Rules and Group policies, including a
                disclaimer.
              </li>
            </ol>
            <h1 className="mb-[2rem] legal-title-y">
              Here Social Media Group(s) including:
            </h1>
            <ol className="pl-[1.5rem] lg:pl-[2.2rem] legal-ol-num-g">
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Groups on WhatsApp (including on Business WhatsApp)
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                WhatsApp Bulletins (including on Business WhatsApp)
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                WhatsApp Broadcasts (including Business WhatsApp)
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Facebook Page:{" "}
                <span className="legal-text-b">GCC Law Help</span>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Facebook Groups:{" "}
                <span className="legal-text-b">GCC Law Help</span>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                LinkedIn Company Page:{" "}
                <span className="legal-text-b">GCC Law Help</span>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Groups and pages on Google created by{"  "}
                <span className="legal-text-b">gcclawhelp@gmail.com</span>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Group and page on Microsoft created by{" "}
                <span className="legal-text-b">gcchelplaw@gmail.com</span>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-g-li">
                Any other social media group created by GCC Law Helps in
                official ID, mail ID, or mobile number.
              </li>
            </ol>
            <p className="mb-[1.5rem] legal-text-fs legal-text-b">
              I have read, understood, and agree above Group Rules, Policy, and
              Disclaimer.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisclaimerCopyrights;
